export default __webpack_public_path__ + "static/media/Group15104.9e650ac0.png";